export default "__VITE_ASSET__DkAQVtsH__"